import type { StateCreator } from 'zustand';

export interface FormFieldsSlice {
	// Field IDs (discovered from DOM)
	quantityFieldId: number | null;
	occupancyFieldId: number | null;

	// Form field values synced from DOM
	quantity: number;
	occupancy: number | null;

	// Actions
	setQuantityFieldId: (id: number | null) => void;
	setOccupancyFieldId: (id: number | null) => void;
	setQuantity: (quantity: number) => void;
	setOccupancy: (occupancy: number | null) => void;
}

export const createFormFieldsSlice: StateCreator<FormFieldsSlice> = (set) => ({
	quantityFieldId: null,
	occupancyFieldId: null,
	quantity: 1,
	occupancy: null,

	setQuantityFieldId: (id) => set({ quantityFieldId: id }),
	setOccupancyFieldId: (id) => set({ occupancyFieldId: id }),
	setQuantity: (quantity) => set({ quantity }),
	setOccupancy: (occupancy) => set({ occupancy }),
});
